
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Mumbaitoshirdi() {



  const cardData =
  {
    keyword: 'Mumbai To Shirdi Cab',
    heading: 'SHREE Tours & Travels: Mumbai To Shirdi Cab',
    headingDescription: 'SHREE Tours & Travels offers a reliable Mumbai to Shirdi Cab service, ensuring a smooth and comfortable journey to the sacred town of Sai Baba. Whether you are traveling for pilgrimage or leisure, our well-maintained Cabs and professional drivers provide a hassle-free experience. With on-time pickups, flexible booking options and affordable fares, we guarantee a safe and convenient ride. Choose SHREE Tours & Travels for a stress-free Mumbai to Shirdi travel experience.',

    top: 'Top Places to Visit in Shirdi  with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shri Sai Baba Samadhi Temple",
        "description": "The Shri Sai Baba Samadhi Temple is the most revered place in Shirdi, where thousands of devotees gather daily to seek blessings from Sai Baba. The temple houses the sacred tomb of Sai Baba, a saint known for his miracles, teachings of love and unity among all religions. Devotees can participate in daily Aartis, including the Kakad Aarti (morning), Madhyan Aarti (noon), Dhoop Aarti (evening) and Shej Aarti (night). The temple complex includes Sai Baba’s statue, a prayer hall and a museum displaying artifacts related to his life. The temple's spiritual ambiance provides a deeply moving and peaceful experience for visitors."
    },
    {
        "title": "Dwarkamai",
        "description": "Dwarkamai is a sacred mosque where Sai Baba spent a significant portion of his life. It is considered the heart of Shirdi, symbolizing his teachings of compassion and equality. Inside, visitors can see the Dhuni (sacred fire) that Baba kept burning continuously, believed to have healing properties. The stone on which Baba used to sit and his wooden plank for sleeping are also preserved here. Dwarkamai reflects Sai Baba’s philosophy of universal brotherhood and remains a place of immense spiritual energy."
    },
    {
        "title": "Chavadi",
        "description": "Chavadi is a small yet historically significant place in Shirdi, where Sai Baba used to sleep every alternate night. It played a crucial role in his daily routine and is now a revered site for devotees. Every Thursday, a grand procession called 'Palki Utsav' takes place, where Sai Baba's portrait is carried in a beautifully decorated palanquin from Dwarkamai to Chavadi. The temple’s wooden interiors and peaceful environment make it a must-visit for those seeking spiritual solace."
    },
    {
        "title": "Gurusthan",
        "description": "Gurusthan, meaning 'Seat of the Guru,' is the place where Sai Baba was first seen in Shirdi as a young boy. Located under a Neem tree, it is believed that Baba meditated here. A shrine has been built, housing a portrait of Sai Baba, a Shiva Linga and a sacred Nandi (bull). The fragrance of incense sticks fills the air and devotees believe that lighting an Agarbatti (incense stick) at Gurusthan helps in fulfilling their wishes. It is a peaceful place for meditation and introspection."
    },
    {
        "title": "Lendi Baug",
        "description": "Lendi Baug is a beautiful garden where Sai Baba used to meditate and spend time in solitude. The garden contains a deep well, a small shrine and a perpetually burning lamp, called 'Nanda Deep,' which was lit by Baba himself. The lush greenery and tranquil environment make it an ideal spot for visitors to reflect and experience the serenity that once surrounded Sai Baba."
    },
    {
        "title": "Khandoba Temple",
        "description": "Khandoba Temple holds great significance in Shirdi’s history, as it was here that Sai Baba was first recognized as a holy figure when he arrived in the town. The temple is dedicated to Lord Khandoba, a form of Lord Shiva. It is a small yet powerful place of worship where visitors can experience deep spiritual energy. The temple priest was among the first to acknowledge Sai Baba’s divine presence, making it an essential stop for devotees exploring Shirdi."
    },
    {
        "title": "Sai Heritage Village",
        "description": "Sai Heritage Village is a unique theme park that showcases important moments from Sai Baba’s life through lifelike statues and exhibits. It provides an immersive experience with scenes depicting his miracles, teachings and daily activities. The village also features a small amusement park for children, making it a great family-friendly destination in Shirdi. Visitors can also enjoy bullock cart rides and traditional village-style meals."
    },
    {
        "title": "Wet N Joy Water Park",
        "description": "For those looking for a fun break, Wet N Joy Water Park in Shirdi offers an exciting experience with thrilling water rides, wave pools and lazy rivers. Spread over a large area, the park is perfect for families and groups who want to unwind after a spiritual journey. The park has well-maintained changing facilities, food courts and safety measures, making it a refreshing destination in the pilgrimage town."
    },
    {
        "title": "Sai Teerth Theme Park",
        "description": "Sai Teerth Theme Park is India’s first spiritual theme park, dedicated to Sai Baba’s life and teachings. It features interactive exhibits, a 5D show depicting Baba’s miracles and an artificial train ride that takes visitors through major pilgrimage sites in India. The highlight of the park is a 45-minute movie on Sai Baba’s life, presented in an engaging and devotional manner. The park offers a unique blend of devotion, history and entertainment."
    },
    {
        "title": "Shani Shingnapur",
        "description": "Located about 70 km from Shirdi, Shani Shingnapur is a famous pilgrimage site dedicated to Lord Shani (Saturn). The temple is unique because the deity is worshipped in the form of a black stone idol without a roof. The village is known for having no doors on houses, as people believe that Lord Shani protects them from theft. Devotees visit the temple to seek blessings and ward off negative energies. Many travelers combine their Shirdi trip with a visit to this remarkable and mysterious village."
    }
],  
    
            
"services": [
    {
      "name": "Mumbai to Shirdi Taxi",
      "description": "Book a comfortable and reliable taxi from Mumbai to Shirdi with SHREE Tours & Travels. We offer a smooth, safe and hassle-free journey to the famous Shirdi temple, with well-maintained cars and experienced drivers to make your trip memorable."
    },
    {
      "name": "Mumbai to Shirdi Cab Service",
      "description": "Choose our efficient and professional Cab service from Mumbai to Shirdi. Whether you're traveling solo, with family, or a group, our fleet of vehicles caters to all your needs, offering both affordability and comfort for the journey."
    },
    {
      "name": "Mumbai to Shirdi One-Way Taxi",
      "description": "Looking for a one-way taxi from Mumbai to Shirdi? Our one-way taxi service ensures you travel comfortably and economically. With no hidden charges and expert drivers, your trip to Shirdi will be smooth and enjoyable."
    },
    {
      "name": "Mumbai to Shirdi Round Trip Cab",
      "description": "Planning a round-trip to Shirdi? Our round-trip Cab service offers the flexibility of returning to Mumbai after your visit. You can choose the duration that suits you and our professional drivers will ensure a safe and comfortable experience throughout."
    },
    {
      "name": "Affordable Mumbai to Shirdi Cab",
      "description": "Get affordable and budget-friendly Cab services for your trip from Mumbai to Shirdi. Our fleet includes well-maintained cars at the best prices, so you can enjoy a comfortable journey without worrying about the cost."
    },
    {
      "name": "Private Taxi for Shirdi Temple from Mumbai",
      "description": "For a more personal and private journey, book a private taxi for your trip from Mumbai to Shirdi. Our experienced drivers ensure you reach the Shirdi temple comfortably and on time, giving you a peaceful and private travel experience."
    },
    {
      "name": "Shirdi Temple Visit with Cab",
      "description": "Plan your visit to the Shirdi temple with ease using our specialized temple visit Cab service. Enjoy a comfortable, guided journey with knowledgeable drivers who will assist you in making your trip spiritually fulfilling and stress-free."
    },
    {
      "name": "Shirdi Cab Hire",
      "description": "Hire a Cab from Mumbai to Shirdi with SHREE Tours & Travels. We offer different types of vehicles, including sedans, SUVs and luxury cars, ensuring that your journey is comfortable and tailored to your preferences."
    },
    {
      "name": "Group Travel for Shirdi from Mumbai",
      "description": "Traveling in a group? Our spacious Cabs are perfect for group trips from Mumbai to Shirdi. Enjoy a comfortable and collective experience with enough space, ensuring that your entire group travels together in comfort."
    },
    {
      "name": "Book Mumbai to Shirdi Car",
      "description": "Book your preferred car from Mumbai to Shirdi today. Whether you prefer a sedan for a small family or an SUV for a more luxurious experience, our range of vehicles ensures you can select the one that fits your needs for a smooth and safe journey."
    },
    {
      "name": "Shirdi Tour by Cab",
      "description": "Take a complete tour of Shirdi with our all-inclusive Cab service. We offer sightseeing tours of Shirdi’s famous temples and other attractions, ensuring you explore this holy town at your own pace with professional guidance."
    },
    {
      "name": "Shirdi Temple Taxi Service",
      "description": "Book our specialized taxi service for a visit to the Shirdi temple. With timely pickups, well-maintained vehicles and skilled drivers, you can enjoy a peaceful and comfortable journey to one of India’s most revered spiritual destinations."
    },
    {
      "name": "Mumbai to Shirdi Cheap Taxi",
      "description": "Looking for an affordable ride to Shirdi? Our cheap taxi service ensures you travel without breaking your budget. With reliable drivers and a fleet of comfortable cars, you’ll get the best value for your money."
    },
    {
      "name": "Shirdi Trip from Mumbai",
      "description": "Planning a trip to Shirdi from Mumbai? Book a Cab with us for a convenient, affordable and comfortable ride. Our experienced drivers ensure you enjoy a smooth trip while focusing on your spiritual journey."
    }
  ],
  "tableData": [
    ["- Mumbai to Shirdi Taxi", "- Mumbai to Shirdi Cab Service"],
    ["- Mumbai to Shirdi One-Way Taxi", "- Mumbai to Shirdi Round Trip Cab"],
    ["- Affordable Mumbai to Shirdi Cab", "- Private Taxi for Shirdi Temple from Mumbai"],
    ["- Shirdi Temple Visit with Cab", "- Shirdi Cab Hire"],
    ["- Group Travel for Shirdi from Mumbai", "- Book Mumbai to Shirdi Car"],
    ["- Shirdi Tour by Cab", "- Shirdi Temple Taxi Service"],
    ["- Mumbai to Shirdi Cheap Taxi", "- Shirdi Trip from Mumbai"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable and Peaceful Journey",
      "WhyChoosedescription": "Our Mumbai to Shirdi Cab service offers a comfortable and peaceful journey, ensuring you travel in comfort with spacious seating, air-conditioning and a smooth ride. Whether you're visiting for religious purposes or leisure, we make sure your trip is pleasant and stress-free."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our experienced drivers are well-acquainted with the best routes from Mumbai to Shirdi. They focus on providing you with a safe, timely and courteous service, ensuring a smooth journey throughout. You can relax knowing you're in the hands of professionals who prioritize your comfort and safety."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive and transparent pricing for your Mumbai to Shirdi Cab ride, ensuring there are no hidden charges. Our pricing structure is designed to provide you with the best value for your money, whether you're booking a one-way or round-trip service."
    },
    {
      "WhyChooseheading": "Well-Maintained Fleet",
      "WhyChoosedescription": "All our vehicles are regularly maintained to ensure they are in top condition. From mechanical checks to cleanliness, we ensure that each vehicle is safe, reliable and comfortable, allowing you to travel without any concerns during your journey from Mumbai to Shirdi."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Shirdi Cab is easy and hassle-free with SHREE Tours & Travels. You can book online via our user-friendly platform or get in touch with our customer service team for assistance. Whether you're booking in advance or at the last minute, we make the process simple and quick."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Mumbai to Shirdi Cab needs. Whether you're planning an early morning departure or a late-night return, we are always available to accommodate your travel schedule, ensuring you're never left stranded."
    },
    {
      "WhyChooseheading": "Local Insights and Recommendations",
      "WhyChoosedescription": "Our drivers are not only skilled drivers but also have a deep knowledge of the local culture and routes between Mumbai and Shirdi. They can offer insights into the best places to visit in Shirdi, including dining recommendations and must-see spots along the way, enhancing your overall experience."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our priority. We are committed to ensuring your Mumbai to Shirdi Cab ride is comfortable, safe and punctual. With our dedication to service excellence, we guarantee a hassle-free and pleasant experience every time."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  



        
  }
  const faqData = [
    {
        question: "How can I book a Cab from Mumbai to Shirdi?",
        answer: "You can easily book your Mumbai to Shirdi Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Mumbai to Shirdi route?",
        answer: "We offer a variety of vehicles for the Mumbai to Shirdi journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Mumbai to Shirdi inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Mumbai to Shirdi?",
        answer: "Yes, we offer one-way rental options for your Mumbai to Shirdi trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Mumbai to Shirdi trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Mumbai to Shirdi Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Mumbai to Shirdi Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Mumbai to Shirdi trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Mumbai to Shirdi?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Mumbai to Shirdi?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The trip from Mumbai to Shirdi was comfortable and hassle-free. The driver was professional and I reached the temple on time.',
        name: 'Mr. Nilesh Deshmukh',
    },
    {
        text: 'I had an excellent experience with SHREE Tours & Travels. The driver was courteous and the vehicle was very clean and comfortable for the Mumbai to Shirdi trip.',
        name: 'Miss. Snehal Patil',
    }
];












  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Mumbai to Shirdi Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/mumbai-to-shirdi-cab.jpg",
    "https://shreetoursandtravels.in/img/shirdi-tour-cab.jpg"
  ],
  "priceRange": "₹2500 - ₹5000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/mumbai-to-shirdi-cab-service",
    "priceCurrency": "INR",
    "price": 2800,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 1100
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Amit Deshmukh"
      },
      "datePublished": "2024-10-15",
      "reviewBody": "The trip from Mumbai to Shirdi was excellent. The driver was very professional and the car was clean and comfortable. Highly recommend!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Patil"
      },
      "datePublished": "2024-10-25",
      "reviewBody": "We had a great experience traveling to Shirdi from Mumbai. The driver was courteous and the trip was smooth and enjoyable."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Mumbai to Shirdi Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.0760,  // Mumbai latitude
      "longitude": 72.8777  // Mumbai longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/mumbai-to-shirdi-cab-service"
  },
  "keywords": "Mumbai to Shirdi Taxi, Mumbai to Shirdi Cab Service, Mumbai to Shirdi One-Way Taxi, Mumbai to Shirdi Round Trip Cab, Affordable Mumbai to Shirdi Cab, Private Taxi for Shirdi Temple from Mumbai, Shirdi Temple Visit with Cab, Shirdi Cab Hire, Group Travel for Shirdi from Mumbai, Book Mumbai to Shirdi Car, Shirdi Tour by Cab, Shirdi Temple Taxi Service, Mumbai to Shirdi Cheap Taxi, Shirdi Trip from Mumbai"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Mumbai to Shirdi Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Mumbai to Shirdi Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Mumbai to Shirdi Taxi, Mumbai to Shirdi Cab Service, Mumbai to Shirdi One-Way Taxi, Mumbai to Shirdi Round Trip Cab, Affordable Mumbai to Shirdi Cab, Private Taxi for Shirdi Temple from Mumbai, Shirdi Temple Visit with Cab, Shirdi Cab Hire, Group Travel for Shirdi from Mumbai, Book Mumbai to Shirdi Car, Shirdi Tour by Cab, Shirdi Temple Taxi Service, Mumbai to Shirdi Cheap Taxi, Shirdi Trip from Mumbai" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/13.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitoshirdi;